import { render, staticRenderFns } from "./AssetLinkControl.vue?vue&type=template&id=492c09b8&lang=pug&"
import script from "./AssetLinkControl.vue?vue&type=script&lang=js&"
export * from "./AssetLinkControl.vue?vue&type=script&lang=js&"
import style0 from "./AssetLinkControl.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports